export class ConfirmController {
    constructor($uibModalInstance, message, title) {
        this.$uibModalInstance = $uibModalInstance;
        this.message = message;
        this.title = title;
    }

    ok() {
        this.$uibModalInstance.close();
    }

    cancel() {
        this.$uibModalInstance.dismiss();
    }
}

ConfirmController.$inject = ['$uibModalInstance', 'message', 'title'];